import React, {useState, useEffect} from 'react';

type ToastMessageProps = {
  className?: string;
  timeOut?: number;
  children: React.ReactNode;
};

const ToastMessage = ({
  className,
  timeOut = 3000,
  children,
}: ToastMessageProps) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(false);
    }, timeOut);

    return () => {
      clearTimeout(timer);
    };
  }, [timeOut]);

  return (
    <div
      className={`bg-dandelion text-tenne rounded-large p-3 ${
        show ? '' : 'hidden'
      } ${className}`}
    >
      {children}
    </div>
  );
};

export default ToastMessage;
